export default {
      id: "lightbulb-usage",
      viewBox: "0 0 433 433",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#lightbulb",
      toString: function () {
        return this.url;
      }
    }